import { formatDate, formatHour } from '@/app/utils/dateUtils';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  label?: string;
  isActive?: boolean;
  importedData: string;
}

export default function StatusBadge({ label, isActive, importedData }: StatusBadgeProps) {
  const hasData = Boolean(importedData);

  const formattedDate = importedData ? formatDate(importedData) : '-----/-----/----';
  const formattedHour = importedData ? formatHour(importedData) : '--:--';

  const { t } = useTranslation('periods');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minWidth: 150,
        px: 2,
        py: 0.5,
        borderRadius: 0.5,
        borderLeft: 4,
        borderLeftColor: isActive ? 'success.main' : 'grey.500',
        bgcolor: isActive ? 'success.light' : 'grey.100',
        color: isActive ? 'success.dark' : 'grey.700',
      }}
    >
      <Typography component="p" variant="fieldHeader">
        {label}
      </Typography>
      {hasData ? (
        <Box
          sx={{
            fontSize: 10,
            opacity: 0.7,
            mb: label ? 0 : 1,
          }}
        >{`${formattedDate} - ${formattedHour}`}</Box>
      ) : (
        <Box
          sx={{
            fontSize: 10,
            opacity: 0.9,
            mb: label ? 0 : 1,
          }}
        >
          {t('not.imported')}
        </Box>
      )}
    </Box>
  );
}
